import React, { useContext } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box,Button, Checkbox, Container, createTheme, FormControlLabel, IconButton, TextField, ThemeProvider, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { ContextNotification, severitys } from '../../App';
import UserApi from '../../api/UserApi';
import helper from '../../helper';
import customtheme from '../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from '../../Components/RtlProvider';
import BeatLoading from '../../Components/Loader/BeatLoader';

const ChangePassword = () => {
    const { open, setOpen } = useContext(ContextNotification);
    const [visiblePass, setVisiblePass] = React.useState(false);
    const [submitLoading,setSubmitLoading]=React.useState(false);
    const navigate = useNavigate();
    const schema = yup.object().shape({
        oldPass: yup.string().required(" کلمه عبور قبلی را وارد نمایید"),
        newPass: yup.string().required(" کلمه عبور جدید را وارد نمایید"),
        newPassReply: yup.string().required("تکرار کلمه عبور جدید را وارد نمایید"),

    });
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });
   
    const customization = useSelector((state) => state.customization);
    const onSubmit = (data) => {


        if (data.newPassReply !== data.newPass)
            setOpen({ IsEnable: true, Message: 'کلمه عبور با تکرار آن متفاوت است', severity: severitys.error });
        else {
setSubmitLoading(true);
            UserApi.ChangePassword(data.oldPass,data.newPass,data.newPassReply)
                .then(() => {
                    setOpen({ IsEnable: true, Message: 'تغییر کلمه عبور با موفقیت اعمال شد', severity: severitys.Message })
                    localStorage.clear();
                   navigate('/login') ;
                })
                .catch((err) => {
                    var errmsg = '';
                    if (err.response && err.response.data && err.response.data[0] && err.response.data[0].code) {
                        var code = err.response.data[0].code;
                        errmsg = helper.renderErrorMessage(code);

                    }

                    if (err.response && err.response.data) {

                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.response.data), severity: severitys.error });
                    }
                    else if (err.response && err.response.data.errors) {

                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.response.data.errors), severity: severitys.error });
                    }
                    else if (err.message) {
                        setOpen({ IsEnable: true, Message: (errmsg !== '') ? errmsg : JSON.stringify(err.message), severity: severitys.error });
                    }
                    else
                        console.log(err)
                }).finally(()=>{setSubmitLoading(false);});



        }
    };
    

    return (
        <RtlProvider>
        <ThemeProvider theme={ customtheme(customization) }>
        <Container component="main" maxWidth="xs" dir="rtl">
             
            <form onSubmit={handleSubmit(onSubmit)}>
        
               
                <div style={{ width: '100%' }}>
                
                    <Typography component="h1" variant="h5">
                        تغییر کلمه عبور
                    </Typography>
                    
                    <TextField sx={{ display: "flex", alignItems: "center" }}  variant="outlined" type="password" {...register("oldPass")} fullWidth label="کلمه عبور قبلی " margin="normal" />
                    <p className="error">{errors.oldPass?.message}</p>
                
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField   variant="outlined" type={visiblePass ? "text" : "password"} {...register("newPass")}  fullWidth label="کلمه عبور جدید " margin="normal" />
                    <p className="error">{errors.newPass?.message}</p>
                   </Box>
                   <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TextField   variant="outlined" type={visiblePass ? "text" : "password"} {...register("newPassReply")}   fullWidth label="تکرار کلمه عبور جدید " margin="normal" />
                    <p className="error">{errors.newPassReply?.message}</p>
                    </Box>
                  
                    <FormControlLabel  control={<Checkbox  defaultUnChecked/>} label="نمایش"  onChange={()=>{setVisiblePass(old => !old)}} />
                </div>
                    <Button type="submit" variant="contained" disabled={submitLoading} color="primary" fullWidth>
                         <BeatLoading loading={submitLoading} color={"#e65100"}/>
                    تغییر کلمه عبور

                    </Button>
              
             
            </form>
       
        </Container>
        </ThemeProvider>
        </RtlProvider>
    )
}
export default ChangePassword;